// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"7792be0a","757":"2ca43380"}[chunkId] + ".chunk.js";
};